export const IS_FACTURACION = process.env.REACT_APP_MODO === 'facturacion';

export const APP_NOMBRE = IS_FACTURACION ? 'Facturación' : 'Bodega';
export const APP_PORTAL = IS_FACTURACION ? 'Portal Facturación' : 'Portal Bodega';
export const APP_PIN_SUB = IS_FACTURACION
  ? 'Un solo PIN para las tablets de Facturación'
  : 'Un solo PIN para todas las tablets de Bodega';
